//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { setOwnKey, COLUMN_SETTINGS } from '@/tools'
import ItemSetting from '../ItemSettings.vue'
import { mapGetters } from 'vuex'
export default {
  props: {
    question: {
      type: Object,
      default: {
        v_ownId: setOwnKey(),
        v_active: false,
        v_label: '单选题',
        type: 'radio',
        displayIndex: true,
        title: '请选择一个选项',
        required: true,
        voteVisible: false,
        column: 1,
        uploadArrow: true,
        uploadArrowRequired: false,
        logic: {
          blocks: {
            typeBlock: 'all',
            list: [],
          },
        },
      },
    },
  },
  filters: {
    setting(value) {
      return value ? COLUMN_SETTINGS[value] : ''
    },
  },
  computed: {
    ...mapGetters(['columnSetting']),
  },
  methods: {
    //布局排列
    columnSettings() {
      new this.$Picker({
        data: [this.columnSetting],
        value: [this.question.column],
        onOk: (values, text, selectedIndex) => {
          this.question.column = values[0]
        },
      })
    },
    //分值设置
    scoreSettings() {
      let _this = this
      let popup = new this.$Popup(ItemSetting, {
        position: 'bottom',
        isMaskClose: true,
        size: '100%',
        question: _this.question,
        onchoose(item) {
          popup.close()
        },
      })
    },
  },
}
